export type QueueState = 'pending' | 'syncing' | 'failed' | 'conflict'
export type QueueOperation = {
  operationId: string
  entityKey: string
  state: QueueState
  payload: Record<string, unknown>
  createdAt: number
  updatedAt: number
  attempts: number
  method?: string
  url?: string
  serverValue?: unknown
  error?: string
}

export function mergePendingOperation(existing: QueueOperation, payload: Record<string, unknown>, now: number, id = () => crypto.randomUUID()): QueueOperation {
  if (existing.state === 'pending' || existing.state === 'failed') return { ...existing, payload, state: 'pending', updatedAt: now, error: undefined }
  return { operationId: id(), entityKey: existing.entityKey, state: 'pending', payload, createdAt: now, updatedAt: now, attempts: 0, method: existing.method, url: existing.url }
}
